/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Columns_HintInputs */



/**
* | output |
* | --- |
* | "Needs an email column. Name and role columns are optional." |
*
* @param {Team_Manager_Import_Columns_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_columns_hint = /** @type {((inputs?: Team_Manager_Import_Columns_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Columns_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une colonne e-mail est requise. Les colonnes nom et rôle sont facultatives.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine E-Mail-Spalte ist erforderlich. Name und Rolle sind optional.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Serve una colonna email. Le colonne nome e ruolo sono facoltative.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нужен столбец с почтой. Столбцы имени и роли необязательны.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Necesita una columna de correo. Las columnas de nombre y rol son opcionales.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要电子邮件列。姓名和角色列为可选。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メール列が必要です。名前と役割の列は任意です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल कॉलम ज़रूरी है। नाम और भूमिका कॉलम वैकल्पिक हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Precisa de uma coluna de email. As colunas de nome e função são opcionais.")
	return /** @type {LocalizedString} */ ("Needs an email column. Name and role columns are optional.")
});